import * as React from 'react';
import { Div } from '../renderNode';
import { ReadOnlyPlugins } from '../../slatePlugins/components/core/readonly/ReadOnlyPlugins';

export const ReadOnlyEditor = React.forwardRef(
  (
    {
      initialValue,
      children,
      WrapperComponent = Div,
      WrapperComponentProps = {},
      renderRight,
      className,
      editorClassName,
      withCustomSpacing,
      isReadOnly, // omit from DOM
      onMounted,
      ...rest
    }: any,
    ref
  ) => {
    React.useEffect(() => {
      onMounted?.();
    }, [onMounted]);
    return <ReadOnlyPlugins className={className} ref={ref} value={initialValue} {...rest} />;
  }
);
